import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    updatedAtMatch: string;
    deletedAtMatch: string;
    insertedAtMatch: string;
    visualMatch: ({ count }: {
        count: number;
    }) => string;
    codecMatch: string;
    transcriptionResultMatch: string;
    commentCountMatch: string;
    pageCountMatch: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Search label for updated date matches. */
            updatedAtMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.updatedAtMatch?c=grfvxntgl36a", defaultMessage: "Date Updated" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for deleted date matches. */
            deletedAtMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.deletedAtMatch?c=20qhca6dkw9wz", defaultMessage: "Date Deleted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for inserted date matches. */
            insertedAtMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.insertedAtMatch?c=13z7g1ohg7qgt", defaultMessage: "Date Inserted" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for visual search matches. */
            visualMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "MatchLabelMap.visualMatch?c=ug4lpchtozwm", defaultMessage: "{count, plural, one {Visual Match} other {Visual Match ({count, number})}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for codec matches. */
            codecMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.codecMatch?c=jxpw0s83538l", defaultMessage: "Codec" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for transcript text matches. */
            transcriptionResultMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.transcriptionResultMatch?c=32qur1iaba295", defaultMessage: "Transcript" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for comment count matches (shorter form for search UI). */
            commentCountMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.commentCountMatch?c=30ob2za738yys", defaultMessage: "Comments" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Search label for page count matches (shorter form for search UI). */
            pageCountMatch: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MatchLabelMap.pageCountMatch?c=32jzjaksxoik", defaultMessage: "Pages" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
